export const STRING = {
  LOGIN: {
    TITLE: "SWU Admin Panel",
    SUBTITLE: "Welcome back to Store With Us",
    EMAIL_LABEL: "user@swu.com",
    PASSWORD_LABEL: "**********",
    SUBMIT_LABEL: "Sign In",
    SUBMIT_LOADING_LABEL: "Signing in...",
    TOAST_ERROR_TITLE: "Error",
    TOAST_ERROR_DEFAULT: "An unexpected error occurred",
  },

  ADMIN: {
    SUBTITLE: "Administrative Panel",
    LOGOUT_TOOLTIP: "Log Out",
    USER_LABEL: "Admin",
    USER_EMAIL: "admin@panel.com",
  },

  SIDEBAR: {
    DASHBOARD: "Dashboard",
    LOCATIONS: "Locations",
    UNITS: "Units",
    RESERVATIONS: "Reservations",
    CHECKOUT: "Checkout",
    CUSTOMERS: "Customers",
    SYNC: "Synchronization",
    INSURANCES: "Insurances",
    GATES: "Access Gates",
    SIZES: "Unit Sizes",
    CONTRACTS: "Contracts & Payments",
  },

  DASHBOARD: {
    WELCOME_TITLE: "Welcome back!",
    WELCOME_SUBTITLE:
      "Manage your business efficiently with the available tools",
    UNIT_STATUS_BY_LOCATION: "Unit Status by Location",
  },

  LOCATION_FORM: {
    TITLE_CREATE: "Create Location",
    TITLE_UPDATE: "Update Location",
    GENERAL_INFORMATION: "General Location Information",
    GENERAL_SUBTEXT:
      "Please complete the necessary data to create or update a location.",
    SECTION_BASIC: "Basic Information",
    SECTION_COORDINATES: "Coordinates",
    SECTION_PROCESSOR: "Processor Details",
    CANCEL_BUTTON: "Cancel",
    CANCEL_ICON: "pi pi-times",
    CREATE_BUTTON: "Create",
    CREATE_ICON: "pi pi-plus",
    UPDATE_BUTTON: "Update",
    UPDATE_ICON: "pi pi-save",
    CONFIRM_DIALOG_MESSAGE:
      "You have unsaved changes. Are you sure you want to leave?",
    CONFIRM_DIALOG_HEADER: "Discard changes",
    CONFIRM_DIALOG_ICON: "pi pi-exclamation-triangle",
    CONFIRM_DIALOG_ACCEPT_CLASS: "p-button-danger",
    INVALID_FILE: "Please select an image file",
    UPLOAD_SUCCESS: "Photo uploaded successfully",
    UPLOAD_FIRST_SUCCESS: "First photo uploaded and set as primary image",
    UPLOAD_ERROR: "Failed to upload photo",
    DELETE_SUCCESS: "Photo deleted successfully",
    DELETE_ERROR: "Failed to delete photo",
    DELETE_CONFIRM: "Are you sure you want to delete this photo?",
    SET_MAIN_SUCCESS: "Photo is now the main location image",
    SET_MAIN_ERROR: "Failed to set main photo",
  },

  UNIT_CATEGORY_FORM: {
    TITLE_CREATE: "Create Unit Category",
    TITLE_UPDATE: "Update Unit Category",
    GENERAL_INFORMATION: "General Unit Category Information",
    GENERAL_SUBTEXT:
      "Please complete the necessary data to create or update a unit category.",
    SECTION_BASIC: "Basic Information",
    SECTION_MEDIA: "Media and Descriptions",
    CANCEL_BUTTON: "Cancel",
    CANCEL_ICON: "pi pi-times",
    CREATE_BUTTON: "Create",
    CREATE_ICON: "pi pi-plus",
    UPDATE_BUTTON: "Update",
    UPDATE_ICON: "pi pi-save",
    CONFIRM_DIALOG_MESSAGE:
      "You have unsaved changes. Are you sure you want to leave?",
    CONFIRM_DIALOG_HEADER: "Discard changes",
    CONFIRM_DIALOG_ICON: "pi pi-exclamation-triangle",
    CONFIRM_DIALOG_ACCEPT_CLASS: "p-button-danger",
  },

  UNIT_DESCRIPTION_FORM: {
    TITLE_CREATE: "Create Unit Description",
    TITLE_UPDATE: "Update Unit Description",
    GENERAL_INFORMATION: "General Unit Description Information",
    GENERAL_SUBTEXT:
      "Please complete the necessary data to create or update a unit description.",
    SECTION_BASIC: "Basic Information",
    SECTION_DETAILS: "Details and Features",
    CANCEL_BUTTON: "Cancel",
    CANCEL_ICON: "pi pi-times",
    CREATE_BUTTON: "Create",
    CREATE_ICON: "pi pi-plus",
    UPDATE_BUTTON: "Update",
    UPDATE_ICON: "pi pi-save",
    CONFIRM_DIALOG_MESSAGE:
      "You have unsaved changes. Are you sure you want to leave?",
    CONFIRM_DIALOG_HEADER: "Discard changes",
    CONFIRM_DIALOG_ICON: "pi pi-exclamation-triangle",
    CONFIRM_DIALOG_ACCEPT_CLASS: "p-button-danger",
  },

  UNIT_SIZE_FORM: {
    TITLE_CREATE: "Create Unit Size",
    TITLE_UPDATE: "Update Unit Size",
    GENERAL_INFORMATION: "General Unit Size Information",
    GENERAL_SUBTEXT:
      "Please complete the necessary data to create or update a unit size.",
    SECTION_BASIC: "Basic Information",
    SECTION_DIMENSIONS: "Dimensions and Location",
    CANCEL_BUTTON: "Cancel",
    CANCEL_ICON: "pi pi-times",
    CREATE_BUTTON: "Create",
    CREATE_ICON: "pi pi-plus",
    UPDATE_BUTTON: "Update",
    UPDATE_ICON: "pi pi-save",
    CONFIRM_DIALOG_MESSAGE:
      "You have unsaved changes. Are you sure you want to leave?",
    CONFIRM_DIALOG_HEADER: "Discard changes",
    CONFIRM_DIALOG_ICON: "pi pi-exclamation-triangle",
    CONFIRM_DIALOG_ACCEPT_CLASS: "p-button-danger",
  },

  CUSTOMER_DETAILS: {
    MODAL_HEADER: "Customer Details",

    PERSONAL_INFO: "Personal Info",
    PERSONAL_SUB: "Basic customer details",

    CONTACT_INFO: "Contact Info",
    CONTACT_SUB: "Ways to reach them",

    LICENSE_INFO: "License & Military",
    LICENSE_SUB: "Verification & status",

    ADDRESS_INFO: "Address",
    ADDRESS_SUB: "Customer residence or business",

    // Personal Info
    FIRST_NAME: "🧍 First Name",
    MIDDLE_NAME: "🧍 Middle Name",
    LAST_NAME: "🧍 Last Name",
    BUSINESS_NAME: "🏢 Business Name",
    BIRTHDAY: "🎂 Birthday",
    ENTITY_NUMBER: "🆔 Entity Number",

    // Contact Info
    EMAIL: "✉️ Email",
    PHONE: "📞 Phone",
    PHONE_TYPE: "📱 Phone Type",
    WEB_PAGE: "🌐 Web Page",
    CAN_TEXT: "💬 Can Text",

    // License Info
    LICENSE: "🪪 Driver's License",
    DL_STATE: "📍 DL State",
    DL_EXPIRATION: "📅 DL Expiration",
    IS_MILITARY: "🎖️ Is Military",
    MILITARY_BRANCH: "🪖 Military Branch",
    MILITARY_STATUS: "📋 Military Status",
    ETS_DATE: "📆 ETS Date",

    // Address Info
    ADDRESS_LINE1: "🏠 Address Line 1",
    ADDRESS_LINE2: "🏠 Address Line 2",
    CITY: "🌆 City",
    STATE: "🌎 State",
    ZIP_CODE: "🔢 Zip Code",
    COUNTRY: "🗺️ Country",

    YES: "Yes",
    NO: "No",
    NO_DATA: "No location data available.",
  },

  LOCATION_DETAILS: {
    MODAL_HEADER: "📍 Location Details",
    LOCATION: "📍 Location",
    UNNAMED_LOCATION: "Unnamed Location",
    IMAGE_LOCATION: "Image Location",

    ADDRESS_NAME: "🏷️ Address Name",
    ADDRESS: "📍 Address",
    ADDRESS2: "📍 Address 2",
    CITY: "🌆 City",
    STATE: "📍 State",
    ZIP_CODE: "📮 Zip Code",
    EMAIL: "✉️ Email",
    PHONE: "📞 Phone",

    TYPE: "🏢 Type",
    STATUS: "✅ Status",

    HOURS_SECTION: "⏰ Hours",
    HOURS_WEEKDAYS: "🕒 Weekday Hours",
    HOURS_WEEKENDS: "🕒 Weekend Hours",
    GATE_HOURS: "🚪 Gate Hours",

    LOCATION_COORDINATES: "📌 Coordinates",
    LATITUDE: "🧭 Latitude",
    LONGITUDE: "🧭 Longitude",

    OWNER_INFO: "👤 Owner / DocuSign",
    OWNER_NAME: "👤 Owner Name",

    PROCESSOR_INFO: "⚙️ Processor",
    PROCESSOR_ID: "🆔 Processor ID",
    PROCESSOR_TYPE: "⚙️ Processor Type",
    PROCESSOR_PASSWORD: "🔒 Processor Password",

    IMAGES_SECTION: "🖼️ Images",
    HOME_PHOTO_URL: "🏠 Home Photo",

    CREATED_AT: "📅 Created At",
    UPDATED_AT: "♻️ Last Updated",

    DEFAULT: "-",
    NO_DATA: "No location data available.",
  },

  INSURANCE_DETAILS: {
    MODAL_HEADER: "📑 Insurance Details",
    UNNAMED: "Unnamed Insurance",
    IDENTIFIER: "🆔 Identifier",
    PROVIDER: "🏢 Provider",
    DESCRIPTION: "📝 Description",
    AMOUNT: "💵 Amount",
    COVERAGE: "🛡️ Coverage",
    LOCATION_ID: "📍 Location ID",
    DEFAULT: "—",
    NO_DATA: "No location data available.",
  },

  UNIT_DETAILS: {
    MODAL_HEADER: "📦 Unit Details",
    NO_DATA: "No unit sizes data available.",

    // Secciones
    GENERAL_INFO: "General Info",
    GENERAL_SUB: "Basic information about the unit",
    DESCRIPTION: "📝 Description",
    DIMENSIONS: "📐 Dimensions",
    LOCATION: "📍 Location",

    // Campos generales
    STATUS: "🏷️ Status",
    CONDITION: "✅ Condition",
    TYPE: "📦 Type",
    FLOOR: "🏢 Floor",
    SORT_ID: "🔢 Sort ID",
    NOTES: "📝 Notes",

    // Campos de descripción
    SIZE_NAME: "📏 Size Name",
    SIZE_DESCRIPTION: "📝 Size Description",
    DESCRIPTION_1: "📝 Description 1",
    DESCRIPTION_2: "📝 Description 2",
    DESCRIPTION_3: "📝 Description 3",
    DESCRIPTION_4: "📝 Description 4",

    // Campos de dimensiones
    WIDTH: "↔️ Width",
    LENGTH: "↕️ Length",
    SQ_FOOTAGE: "📐 Square Footage",

    // Campos de ubicación
    LOCATION_NAME: "📍 Location Name",
    LOCATION_ID: "🆔 Location ID",

    // Otros existentes
    SIZE_INFO: "Size Information",
    SIZE_SUB: "Dimensions and pricing",
    SIZE: "📐 Size",
    MEASUREMENT_UNIT: "📏 Measurement Unit",
    DEFAULT_RATE: "💲 Default Rate",
    MANAGED_RATE: "📉 Managed Rate",
    PRICE: "💰 Price",
    AUTO_DISCOUNTS: "🏷️ Auto Discounts",
    FACILITIES: "⭐ Facilities",

    TITLE_CREATE: "Create Unit",
    TITLE_UPDATE: "Update Unit",
    GENERAL_INFORMATION: "General Unit Information",
    GENERAL_SUBTEXT:
      "Please complete the necessary data to create or update a unit.",
    SECTION_BASIC: "Basic Information",
    SECTION_DIMENSIONS: "Dimensions and Location",
    CANCEL_BUTTON: "Cancel",
    CANCEL_ICON: "pi pi-times",
    CREATE_BUTTON: "Create",
    CREATE_ICON: "pi pi-plus",
    UPDATE_BUTTON: "Update",
    UPDATE_ICON: "pi pi-save",
    CONFIRM_DIALOG_MESSAGE:
      "You have unsaved changes. Are you sure you want to leave?",
    CONFIRM_DIALOG_HEADER: "Discard changes",
    CONFIRM_DIALOG_ICON: "pi pi-exclamation-triangle",
    CONFIRM_DIALOG_ACCEPT_CLASS: "p-button-danger",
  },

  GATE_DETAILS: {
    MODAL_HEADER: "🚪 Access Gate Details",

    SECTION_USER: "User Info",
    SECTION_ACCESS: "Access Details",

    UNIT_NAME: "🏢 Unit Name",
    UNIT_ID: "🆔 Unit ID",
    PHONE_NUMBER: "📞 Phone Number",
    USER_NUMBER: "🔢 User Number",

    GATE_ACCESS_CODE: "🔑 Gate Access Code",
    DENY_GATE_ACCESS: "🚫 Deny Gate Access",
    KEYPAD_ZONE: "📍 Keypad Zone",
    GATE_TIME_ZONE: "🕒 Gate Time Zone",

    DEFAULT: "Not Set",
  },

  UNIT_SIZE_DETAILS: {
    MODAL_HEADER: "📐 Unit Size Details",
    NO_DATA: "No unit sizes data available.",
    CONFIRM_DELETE: "Confirm Delete",
    DELETE_WARNING: "Are you sure you want to delete this Unit Category?",
    DELETE_SUCCESS: "Unit description successfully deleted",
    DELETE_ERROR: "Something went wrong, try again later",
  },

  UNIT_CATEGORY_DETAILS: {
    MODAL_HEADER: "🏷 Unit Category Details",
    NO_DATA: "No unit sizes data available.",
    CONFIRM_DELETE: "Confirm Delete",
    DELETE_WARNING: "Are you sure you want to delete this Unit Category?",
    DELETE_SUCCESS: "Unit description successfully deleted",
    DELETE_ERROR: "Something went wrong, try again later",
  },

  SIZE_DETAILS: {
    MODAL_HEADER: "📐 Size Details",

    // Sections
    SECTION_DIMENSIONS: "Dimensions",
    SECTION_RATES: "Rates",
    SECTION_META: "Metadata",
    SECTION_DESCRIPTIONS: "Descriptions",
    SECTION_MEDIA: "Media",

    // Dimension / basic
    NAME: "📛 Name",
    SIZE: "📦 Size",
    SUMMARY: "📝 Summary",
    SQ_FOOTAGE: "📐 Sq. Footage",
    FLOOR: "🏢 Floor",
    WIDTH: "↔️ Width",
    LENGTH: "↕️ Length",
    MEASUREMENT_UNIT: "📏 Measurement Unit",
    IMAGE_UNIT: "Image Unit",

    // Extended descriptions
    DESCRIPTION_1: "📝 Description 1",
    DESCRIPTION_2: "📝 Description 2",
    DESCRIPTION_3: "📝 Description 3",
    DESCRIPTION_4: "📝 Description 4",

    // Media
    WEBSITE_PHOTO: "🖼️ Website Photo",
    LOCATION_PHOTO: "📸 Location Photo",

    // Rates (keep if you still use them)
    PRICE: "💰 Price",
    DEFAULT_MONTHLY_RATE: "💲 Default Rate",
    MANAGED_MONTHLY_RATE: "📉 Managed Rate",
    AUTO_DISCOUNTS: "🏷️ Auto Discounts",

    // Location / metadata
    LOCATION_ID: "📍 Location ID",
    LOCATION_NAME: "📍 Location Name",
    ADDRESS_NAME: "🏷️ Address Name",
    ADDRESS: "📍 Address",
    ADDRESS2: "🏷️ Address 2",
    CITY: "🌆 City",
    STATE: "📍 State",
    ZIP_CODE: "📮 Zip Code",
    EMAIL: "✉️ Email",
    PHONE: "📞 Phone",
    FACILITIES: "⭐ Facilities",
    HOURS_WEEKDAYS: "🕒 Weekday Hours",
    HOURS_WEEKENDS: "🕒 Weekend Hours",
    GATE_HOURS: "🚪 Gate Hours",
    COORDINATES: "📌 Coordinates",

    // Titles
    TITLE_CREATE: "Create Size",
    TITLE_UPDATE: "Update Size",

    NO_DATA: "No location data available.",

    CONFIRM_DELETE: "Confirm Delete",
    DELETE_WARNING: "Are you sure you want to delete this Unit Category?",
    DELETE_SUCCESS: "Unit description successfully deleted",
    DELETE_ERROR: "Something went wrong, try again later",
  },

  CONTRACT_DETAILS: {
    MODAL_HEADER: "Contract Details",
    NO_DATA: "No contract data available.",

    CONTRACT_INFO: "Contract Info",
    CONTRACT_NUMBER: "Contract Number",
    CUSTOMER: "Customer",
    EMAIL: "Email",
    UNIT: "Unit",
    SIZE: "Size",
    LOCATION: "Location",
    MOVED_IN: "Moved In",
    MOVED_OUT: "Moved Out",
    ACCESS_CODE: "Access Code",
    RATE: "Monthly Rate",

    PAYMENT_STATUS: "Payment Status",
    BALANCE: "Balance",
    PAID_THROUGH: "Paid Through",
    DEPOSIT: "Deposit",
    DELINQUENCY: "Delinquency Status",
    AUTO_PAY: "Auto Pay",

    PAYMENT_HISTORY: "Payment History",
    NO_PAYMENTS: "No payments recorded",
  },

  UNIT_STATUS: {
    RENTED: "Rented",
    RESERVED: "Reserved",
    AVAILABLE: "Available",
    READY: "Ready",
    DIRTY: "Dirty",
  },

  UNITS_DESCRIPTION_IMAGE_UPLOADER: {
    TITLE: "Units Descriptions Image",
    PREVIEW_ALT: "Preview",
    NO_IMAGE: "No image selected",
    CHOOSE_FILE: "Choose Image File",
    SELECTED: "Selected",
    UPLOAD_BUTTON: "Upload Image",
    UPLOAD_ERROR: "Error uploading the image",
  },

  LOCATION_IMAGE_UPLOADER: {
    TITLE: "Location Image",
    PREVIEW_ALT: "Preview",
    NO_IMAGE: "No image selected",
    CHOOSE_FILE: "Choose Image File",
    SELECTED: "Selected",
    UPLOAD_BUTTON: "Upload Image",
    UPLOAD_ERROR: "Error uploading the image",
  },

  UNIT_SIZE_IMAGE_UPLOADER: {
    TITLE: "Unit Size Image",
    PREVIEW_ALT: "Preview",
    NO_IMAGE: "No image selected",
    CHOOSE_FILE: "Choose Image File",
    SELECTED: "Selected",
    UPLOAD_BUTTON: "Upload Image",
    UPLOAD_ERROR: "Error uploading the image",
  },

  UNIT_CATEGORY_VIDEO_UPLOADER: {
    TITLE: "Unit Category Video",
    PREVIEW_ALT: "Video Preview",
    NO_VIDEO: "No video selected",
    CHOOSE_FILE: "Choose Video File",
    SELECTED: "Selected",
    UPLOAD_BUTTON: "Upload Video",
    UPLOAD_ERROR: "Error uploading the video",
  },

  UNIT_DESCRIPTION: {
    CREATE: "Create Unit Description",
    UPDATE: "Update Unit Description",
    UPLOAD_IMAGE_BTN: "Upload image",
    SELECT_IMAGE: "Select unit description image*",
    CONFIRM_DELETE: "Confirm Delete",
    DELETE_WARNING: "Are you sure you want to delete this Unit Description?",
  },
};
